export default function InlineHint({ title = "Tip", children }) {
  return (
    <div className="inline-hint" role="note" aria-label={title}>
      <strong>{title}</strong>
      <p>{children}</p>
    </div>
  );
}
